import { render } from "./OnWorkingToday.vue?vue&type=template&id=b345b8cc"
import script from "./OnWorkingToday.vue?vue&type=script&lang=js"
export * from "./OnWorkingToday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__